'use strict';

function MarketingConsent() {
  this.id = null;
  this.node = null;
  this.$node = null; // Account Dashboard
  this.declaredClass = null;
  this.extends = [];
  this.notifications = null;
  this._OptedIn = null;

  this.el = {};
  this._classes = {
    dashboardSectionMarketingConsent: 'dashboard-section--marketing-consent',
    emailConsentToggle: 'js--marketing-emails-toggle',
    optInDialog: 'MarketingConsentOptInDialog',
    optOutDialog: 'MarketingConsentOptOutDialog',
    dialogContent: 'js--boolean-dialog-content',
    dialogConfirm: 'js--marketing-consent-confirm',
    dialogCancel: 'js--marketing-consent-cancel'
  };

  this._currentDialogId = null;
  this._currentDialogClass = null;
  this._optedInConfirmationMsg = 'You will now receive news, offers, and tips via email. Woo!';
  this._optedOutConfirmationMsg = "We've removed you from our list, and are sad to see you go. Remember, you can opt in anytime.";

  this.init = function () {
    this.$node = $(this.node);
    this.notifications = $('#Notification');
    this.setupMarketingConsentSettings();
  };

  this.setupMarketingConsentSettings = function () {
    this.el.$settingsPanel = this.$node.find('.' + this._classes.dashboardSectionMarketingConsent);
    this.el.$emailConsentToggle = this.$node.find('.' + this._classes.emailConsentToggle);

    this.retrieveMarketingConsent(this._onMarketingConsentSetup.bind(this));
  };

  this.retrieveMarketingConsent = function (callback) {
    if (this.presenter.hasAction('account.index_marketing_opt')) {
      if (typeof this.presenter.models.marketingOptions === 'undefined') {
        this.presenter.performAction('account.index_marketing_opt', null, this._onRetrieveMarketingConsent.bind(this, callback));
      } else {
        callback(null);
      }
    } else {
      callback(null);
    }
  };

  this._onRetrieveMarketingConsent = function (callback, data, response) {
    if (this.presenter.models.marketingOptions) {
      this.presenter.updateModel('marketingOptions', data);
    } else {
      this.presenter.createModel('marketingOptions', { data: data });
    }
    callback(data, response);
  };

  this._onMarketingConsentSetup = function () {
    var activeOption = this.presenter.models.marketingOptions.marketing_opts;
    // currently we will only get 1 record for a user
    if (activeOption.length > 0) {
      this.presenter.createModel('marketingNewsConsent', { data: activeOption[0] });
    } else {
      console.error('Marketing News Consent data not found.');
    }
    var dependantModels = [this.presenter.models.marketingOptions._initializedPromise, this.presenter.models.marketingNewsConsent._initializedPromise];
    $.when(dependantModels).done(this._onMarketingConsentReady.bind(this));
  };

  this._onMarketingConsentReady = function () {
    this._refreshMarketingConsentState();

    this.el.$emailConsentToggle.on('click.marketingConsent', this._loadMarketingConsentDialog.bind(this));
  };

  this._refreshMarketingConsentState = function () {
    this._OptedIn = this.presenter.getModelProperty('marketingNewsConsent.opted_in') === true;
    // Current Dialog is for the opposite of the current state:
    this._currentDialogClass = this._OptedIn ? this._classes.optOutDialog : this._classes.optInDialog;
    this._currentDialogId = '#' + this._currentDialogClass;
    this.presenter.updateDOM(this.el.$settingsPanel);
    this.analytics.pushEvent('marketing-consent-view', {
      MarketingConsent: [this._OptedIn]
    });
  };

  this._loadMarketingConsentDialog = function () {
    var dialogUrl = this._OptedIn ? '/member/account/marketing-consent-opt-out' : '/member/account/marketing-consent-opt-in';
    var onUrlLoaded = this._onMarketingConsentDialogLoaded.bind(this);
    var onClose = this._onCloseDialog.bind(this, this._OptedIn);

    if (!$(this._currentDialogId).length) {
      var dialog = $('<div class="small-12 medium-9 large-8 xlarge-6 columns"></div>').mogo().create('Dialog', {
        close: false,
        onClickClose: onClose,
        backgroundClose: true,
        url: dialogUrl,
        presenter: this.presenter,
        onUrlLoaded: onUrlLoaded,
        id: this._currentDialogClass
      });
    } else {
      $(this._currentDialogId).mogo().show();
    }
    this.analytics.forcePushEvent('marketing-consent-dialog-view', {
      MarketingConsent: [this._OptedIn]
    });
  };

  this._onCloseDialog = function (originalState) {
    this.analytics.forcePushEvent('marketing-consent-dialog-close', {
      MarketingConsent: [originalState]
    });
    this.analytics.forcePushEvent('virtual-page-view');
  };

  this._onMarketingConsentDialogLoaded = function () {
    var _$marketingEmailsDialog = $(this._currentDialogId);
    var _$dialogContent = _$marketingEmailsDialog.find('.' + this._classes.dialogContent);
    var _$submitCTA = _$dialogContent.find('.' + this._classes.dialogConfirm);
    var _$cancelCTA = _$dialogContent.find('.' + this._classes.dialogCancel);

    _$dialogContent.mogo().parse();

    // opt in:
    _$submitCTA.on('click.marketingConsent', this._submitDialogAction.bind(this));

    // cancel:
    _$cancelCTA.on('click.marketingConsent', function () {
      _$marketingEmailsDialog.mogo().hide();
      _$marketingEmailsDialog.mogo().destroy();
    });

    _$marketingEmailsDialog.mogo().show();
  };

  this._submitDialogAction = function () {
    this._setDisabledButtonState(true);
    this.toggleMarketingConsent(this._onDialogActionCompleted.bind(this));
  };

  this.toggleMarketingConsent = function (callback) {
    if (this.presenter.hasAction('marketingNewsConsent.update_marketing_opt')) {
      this.presenter.performAction('marketingNewsConsent.update_marketing_opt', { opted_in: !this._OptedIn }, // toggle current state
      this._onToggleMarketingConsent.bind(this, callback));
    } else {
      console.error('update_marketing_opt is required to perform this action.');
    }
  };

  this._onToggleMarketingConsent = function (callback, data, response) {
    if (response === 200) {
      // Note: just updating the one property we care about:
      this.presenter.setModelProperty('marketingNewsConsent.opted_in', data.opted_in);
      this.presenter.performAction('marketingOptions.self', null, this._onRefreshMarketingConsentModel.bind(this, callback, data, response));
      return;
    }
    if (callback) callback(data, response);
  };

  this._onRefreshMarketingConsentModel = function (callback, data, response, marketingOptionsData, marketingOptionsResponse) {
    this.presenter.updateModel('marketingOptions', marketingOptionsData);
    if (callback) callback(data, response);
  };

  this._onDialogActionCompleted = function (data, response) {
    this._setDisabledButtonState(false);

    var notificationComponent = this.notifications.mogo();

    $(this._currentDialogId).mogo().hide();

    $(this._currentDialogId).mogo().destroy();

    if (response === 200) {
      var message = this._OptedIn ? this._optedOutConfirmationMsg : this._optedInConfirmationMsg;

      this.analytics.forcePushEvent('marketing-consent-update', {
        MarketingConsent: [this._OptedIn, 'Success']
      });

      notificationComponent.create({
        type: 'success',
        msg: message
      });
    } else {
      notificationComponent.create({
        type: 'error'
      });

      this.analytics.forcePushEvent('marketing-consent-update', {
        MarketingConsent: [this._OptedIn, 'Error']
      });
    }

    this._refreshMarketingConsentState();
  };

  this._setDisabledButtonState = function (disabled) {
    var _$submitCTA = $(this._currentDialogId).find('.' + this._classes.dialogConfirm);
    if (disabled) {
      _$submitCTA.mogo().setDisabledLoadState();
      _$submitCTA.off('click.marketingConsent'); // just do once
    } else {
      _$submitCTA.mogo().removeDisabledLoadState();
      _$submitCTA.on('click.marketingConsent', this._submitDialogAction.bind(this));
    }
  };

  this.initAllReady = function () {};

  this.destroy = function () {};
}